/*
* Story Theme
*
* Use this file to add custom Javascript to Story.  Keeping your custom
* Javascript in this fill will make it easier to update Story. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function () {
    // Keep your scripts inside this IIFE function call to avoid leaking your
    // variables into the global scope.

    const headerHamburger = document.querySelector('[data-drawer-toggle="hamburger"]');
    const headerDrawer = document.querySelector('[data-section-type="header"]');
    const svgPaths = document.querySelectorAll('#logo-milk-header-index path');

    headerHamburger.addEventListener('click', () => {
        const status = headerDrawer.classList.toggle('has-drawer-open');
        svgPaths.forEach(path => path.classList.toggle('x-fill-black', status));
        svgPaths.forEach(path => path.classList.toggle('x-fill-[#f6f0e4]', !status));
    });

    // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
    // variables into the global scope.
})();



// const logo = document.querySelector(".header__logo .logo__img");
// if (logo) {
//     logo.style.setProperty("border", "2px solid red", "important");
// } else {
//     console.error("Element not found!");
// }






// document.addEventListener("DOMContentLoaded", function () {
//   console.log('test');
//     const logoImg = document.querySelector(".header__logo .logo__img"); // Select the <img> inside .header__logo
//     if (logoImg) {
//         // logoImg.style.cssText = "border: 2px solid red !important;";
//        console.log('test fine');
//     } else {
//         console.error("Logo image not found!");
//        console.log('test2');
//     }
// });




// function checkHeaderClass() {
//     const header = document.querySelector('.header__wrapper'); // Replace with your actual header selector

//     if (!header) {
//         console.error('Header element not found!');
//         return;
//     }

//     setInterval(() => {
//         if (header.classList.contains('js__header__stuck')) {
//             // console.log('js__header__stuck is ACTIVE');
//           document.querySelectorAll(".logo__img").forEach(img => {
//               img.setAttribute("srcset", "https://cdn.shopify.com/s/files/1/0642/8757/2124/files/Vector.svg?v=1742222914");
//           });
//           document.querySelectorAll(".logo__img").forEach(img => {
//               img.setAttribute("src", "https://cdn.shopify.com/s/files/1/0642/8757/2124/files/Vector.svg?v=1742222914");
//           });
//         } else {
//             // console.log('js__header__stuck is NOT ACTIVE');
//             document.querySelectorAll(".logo__img").forEach(img => {
//               img.setAttribute("srcset", "https://cdn.shopify.com/s/files/1/0642/8757/2124/files/Vector_1.svg?v=1742305954");
//             });
//             document.querySelectorAll(".logo__img").forEach(img => {
//               img.setAttribute("src", "https://cdn.shopify.com/s/files/1/0642/8757/2124/files/Vector_1.svg?v=1742305954");
//             });

//         }
//     }, 1); // Runs every millisecond
// }

// // Call the function to start checking
// checkHeaderClass();


// for B2B login 
  const addLoginHref = () => {
    const loginLinks = document.querySelectorAll(".lockAccess__wrapper a.smt-plain-text");
    loginLinks.forEach(link => {
      if (!link.hasAttribute("href")) {
        link.setAttribute("href", "/account/login"); // You can customize this
        link.style.cursor = "pointer";
      }
    });
  };

  // Initial run
  addLoginHref();

  // Observe changes to the DOM in case elements are added later
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(() => {
      addLoginHref();
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });







